class UTM {
  constructor(url) {
    this.url = new URL(url);
    this.params = this.url.searchParams;
    this.utmParams = {};
    this.links = document.querySelectorAll('a[href*="home.color.com"]');
    this.cookieName = 'STYXKEY_cg_utm';
  }

  init() {
    if (0 === this.links.length) {
      return;
    }

    const cookie = this.getCookie();
    const params = this.getParams();
    const hasCookie = 0 !== Object.keys(cookie).length;
    const hasParams = 0 !== Object.keys(params).length;
    let utmParams;
    let saveToCookie = true;

    if (false === hasCookie && false === hasParams) {
      return;
    }

    if (true === hasCookie && true === hasParams) {
      if (JSON.stringify(cookie) === JSON.stringify(params)) {
        saveToCookie = false;
      }

      utmParams = {...params};
    } else if (true === hasCookie && false === hasParams) {
      saveToCookie = false;
      utmParams = {...cookie};
    } else if (false === hasCookie && true === hasParams) {
      utmParams = {...params};
    }

    if (true === saveToCookie) {
      this.saveParamsIntoCookie(utmParams);
    }

    this.setParamsToLinks(utmParams);
  }

  getParams() {
    const params = {};

    for (const param of this.params) {
      const paramName = param[0];
      const paramValue = param[1];

      if (true === paramName.startsWith('utm_')) {
        params[paramName] = paramValue;
      }
    }

    return params;
  }

  getCookie() {
    const matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" + this.cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)" // eslint-disable-line
      )
    );

    return matches ? JSON.parse(decodeURIComponent(matches[1])) : {};
  }

  doesCookieExist() {
    if (null !== this.getCookie()) {
      return true;
    }

    return false;
  }

  saveParamsIntoCookie(params) {
    const expires = new Date();
    expires.setTime(expires.getTime() + 90 * 24 * 60 * 60 * 1000);
    document.cookie = this.cookieName + '=' + JSON.stringify(params) + '; Expires=' + expires.toUTCString() + '; Path=/; SameSite=Strict; Secure;';
  }

  setParamsToLinks(params) {
    this.links.forEach((link) => {
      const linkUrl = new URL(link);

      for (const key in params) {
        if (Object.hasOwn(params, key)) {
          linkUrl.searchParams.set(key, params[key]);
        }
      }

      link.href = linkUrl.toString();
    });
  }
}

const utm = {
  init() {
    const currentUrl = window.location.href;
    const utmElement = new UTM(currentUrl);
    utmElement.init();
  },
};

export default utm;
